// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ea0f9436","455":"30d88770","977":"d78670f7"}[chunkId] + ".chunk.js";
};